import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api } from "../lib/api";
import { slugify } from "../lib/slug";

/** Short share-link resolver.
 * `/s/:code` → fetch slot by share_code → redirect to canonical /track/{rank}/{slug}.
 * Keeps share URLs tiny while still landing on the SEO-friendly canonical URL.
 */
export default function ShareRedirect() {
  const { code } = useParams();
  const [target, setTarget] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get(`/share/${encodeURIComponent(code)}`)
      .then(({ data }) => {
        if (cancelled) return;
        const slug = slugify(data.artist_name, data.song_title);
        const path = slug ? `/track/${data.rank}/${slug}` : `/track/${data.rank}`;
        setTarget(path);
      })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [code]);

  if (error) return <Navigate to="/" replace />;
  if (target) return <Navigate to={target} replace />;
  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-900 text-zinc-400 text-sm" data-testid="share-redirect-loading">
      Loading share…
    </div>
  );
}
